/**
 * Erreurs du module Interview Preparation (Préparation d'Entretien)
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const INTERVIEW_PREPARATION_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.INTERVIEW_PREPARATION_REVIEW_NOT_FOUND]: {
        messageKey: 'the-selected-review-was-not-found',
        severity: 'error',
    },
    [ERROR_CODES.INTERVIEW_PREPARATION_TEMPLATE_NOT_FOUND]: {
        messageKey: 'review-word-template-not-found-you-can-add-one-in-admin-modules-and-select-competency-folder',
        severity: 'error',
    },
};
